export type ApiState<T> =
  | { state: 'loading'; data?: undefined; error?: undefined }
  | { state: 'success'; data: T; error?: undefined }
  | { state: 'error'; error: string; data?: undefined };

/**
 * Extracts a user-facing error message from an HTTP error or unknown error object.
 * Checks common shapes: HttpErrorResponse.error.message, .error.Message, .message.
 */
export function extractHttpErrorMessage(err: unknown): string {
  if (err && typeof err === 'object') {
    if ('error' in err) {
      const inner = (err as Record<string, unknown>)['error'];
      if (typeof inner === 'string') return inner;
      if (inner && typeof inner === 'object') {
        const msg =
          (inner as Record<string, unknown>)['message'] ??
          (inner as Record<string, unknown>)['Message'];
        if (typeof msg === 'string') return msg;
      }
    }
    if ('message' in err) {
      const msg = (err as Record<string, unknown>)['message'];
      if (typeof msg === 'string') return msg;
    }
  }
  return 'Ein unerwarteter Fehler ist aufgetreten.';
}
